import { render } from "./Glowup.vue?vue&type=template&id=28c22f18"
import script from "./Glowup.vue?vue&type=script&lang=js"
export * from "./Glowup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__